import crypto from "crypto";

const generateUid = (count) => crypto.randomBytes(count).toString("hex")

export default generateUid